import { useLang } from "../../contexts/LanguageContext";
import { imageUrl } from "../../lib/api";

export default function Hero({ content }) {
  const { t } = useLang();
  const heroImg = content?.hero?.image ? imageUrl(content.hero.image) : null;

  return (
    <section
      className="relative w-full bg-[#1b1c1e] text-white overflow-hidden"
      style={{ minHeight: "92vh" }}
      data-testid="hero-section"
    >
      {heroImg && (
        <img
          src={heroImg}
          alt=""
          loading="eager"
          decoding="async"
          className="absolute inset-0 w-full h-full object-cover opacity-70"
          aria-hidden
        />
      )}
      <div className="absolute inset-0 bg-gradient-to-t from-[#1b1c1e]/90 via-[#1b1c1e]/30 to-transparent pointer-events-none" />

      <div className="relative container-x pt-32 pb-16 md:pt-40 md:pb-24 min-h-[92vh] flex flex-col justify-end">
        <h1
          className="font-display font-bold text-white text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.02] max-w-[16ch]"
          data-testid="hero-headline"
        >
          {t(content?.hero?.headline)}
        </h1>
        <p
          className="mt-6 text-base md:text-lg text-white/80 max-w-[58ch] leading-relaxed"
          data-testid="hero-supporting"
        >
          {t(content?.hero?.supporting)}
        </p>
      </div>

      <div
        className="absolute bottom-4 right-6 md:right-10 text-[11px] tracking-wide text-white/60"
        data-testid="hero-credit"
      >
        {t(content?.hero?.image_credit)}
      </div>
    </section>
  );
}
